import ContactForm from "../modules/contact-form";
import Helpers from "../utils/helpers";

window.onLoginSubmit = function (token) {
  const formEl = $("#login");

  ContactForm.addLoader(formEl);

  if (Helpers.validate(formEl)) {
    WooAccount.recaptcha(formEl, token);
  } else {
    ContactForm.removeLoader(formEl);
  }
};

window.onRegisterSubmit = function (token) {
  const formEl = $("#register");

  ContactForm.addLoader(formEl);

  if (Helpers.validate(formEl)) {
    WooAccount.recaptcha(formEl, token);
  } else {
    ContactForm.removeLoader(formEl);
  }
};

const WooAccount = {
  init() {
    this.events();
  },

  events() {
    const accountInfo = $(".account-info");
    const accountFroms = $(".account-form");

    $("[data-target]").on("click", (e) => {
      e.preventDefault();
      const el = $(e.currentTarget);
      const target = el.data("target");
      const targetEl = $(`#${target}`);

      if (targetEl.hasClass("hidden")) {
        accountInfo.attr("data-active", target);
      } else {
        accountInfo.attr("data-active", "form-info");
      }

      const activeEl = $(`#${accountInfo.attr("data-active")}`);
      accountFroms.addClass("hidden");
      activeEl.removeClass("hidden");
    });

    // Person toggle.
    const personTypeEl = $(".person-type-selector");

    personTypeEl.each((i, el) => {
      $(el).hasClass("active") && WooAccount.handlePersonType($(el).val());
    });

    personTypeEl.on("click", function (e) {
      var el = $(e.currentTarget);

      personTypeEl.removeClass("active");
      el.addClass("active");

      WooAccount.handlePersonType(el.val());
    });

    // Address form.
    $(".edit-address").on("submit", function (e) {
      e.preventDefault();

      const formEl = $(this);

      if (Helpers.validate(formEl)) {
        WooAccount.handleForm(formEl);
      } else {
        return false;
      }
    });

    // Change password form.
    $(".change-password").on("submit", function (e) {
      e.preventDefault();

      const formEl = $(this);

      if (Helpers.validate(formEl)) {
        WooAccount.handleForm(formEl);
      } else {
        return false;
      }
    });

    let newsletterTimeout = null;
    $(".newsletter-preferences input").on("change", function () {
      clearTimeout(newsletterTimeout);

      const formEl = $(this).closest("form");

      newsletterTimeout = setTimeout(() => {
        const data = formEl.serializeArray();

        $.ajax({
          type: "POST",
          url: formEl.attr("action"),
          data: data,
        });
      }, 500);
    });

    $(document).on("change", `[name="billing_is_vat"]`, (e) => {
      const vatNrWrap = $("[name=billing_vat_nr]").closest(".col");

      if (e.currentTarget.checked) {
        vatNrWrap.removeClass("hidden");
      } else {
        vatNrWrap.addClass("hidden");
      }
    });
  },

  handlePersonType(persontype) {
    $("[name=billing_person]").val(persontype);

    if (persontype === "private") {
      $(".legal").addClass("hidden");
      $(".private").removeClass("hidden");
    } else {
      $(".legal").removeClass("hidden");
      $(".private").addClass("hidden");
    }
  },

  recaptcha(formEl, token) {
    formEl.find("[name=token]").val(token);
    formEl.submit();
  },

  handleForm(formEl) {
    const data = formEl.serializeArray();

    ContactForm.addLoader(formEl);

    $.ajax({
      type: "POST",
      url: formEl.attr("action"),
      data: data,
    })
      .done((response) => {
        if (response.data.customer_info) {
          $("#customer-info").html(response.data.customer_info);
        }

        if (response.success) {
          formEl.find(".form-message").html(response.data.message);
          formEl
            .find(".form-message")
            .removeClass("hidden")
            .addClass("success");
        } else {
          formEl.find(".form-message").html(response.data.message);
          formEl.find(".form-message").removeClass("hidden").addClass("error");
        }
      })
      .always(() => {
        ContactForm.removeLoader(formEl);
      });
  },
};

export default WooAccount;
